
export default {
  layout: 'product',
  head() {
    return {
      title: "Page is Closed",
      meta: [
        { name: 'description', content: 'Page is Closed' },
        { name: 'robots', content: 'noindex, nofollow' },
      ],
    }
  },
}
